module.exports = global["$"] = require("-!/media/aram/data/konsolenkost/projects/plugin-ceres/node_modules/expose-loader/index.js?jQuery!./jquery.js");